export default "__VITE_ASSET__cp1SFwC7__"